(() => {
    const $textBlocks = document.querySelectorAll('.text-block');

    if (!$textBlocks) return;

    $textBlocks.forEach($textBlock => {
        const $box = $textBlock.querySelector('.text-block__box');
        const $backgroundRight = $textBlock.querySelector('.text-block__background--right');

        const updateBackgroundRightWidth = () => {
            if (!$backgroundRight) return;

            $backgroundRight.style.width = `${(document.body.offsetWidth - $box.clientWidth) / 2}px`;
        };

        window.addEventListener('load', updateBackgroundRightWidth);
        window.addEventListener('resize', updateBackgroundRightWidth);

        updateBackgroundRightWidth();
    });
})();
